import { Metadata } from './metadata'

type base64zip = string;

export interface PackageRef {
  name: string;
  namespace: string;
}

export interface PackageSourceLiteral {
  type: 'literal';
  literal: base64zip;
}

export type PackageSource = PackageSourceLiteral

export interface PackageSpec {
  source: PackageSource;
}

export interface Package {
  meta: Metadata;
  spec: PackageSpec;
}

export class PackageAPI {
  public static get (ref: PackageRef, cb: (f: Package) => void) {
    fetch(`/apis/fission.io/v1/namespaces/${ref.namespace}/packages/${ref.name}`).then(
      response => response.json().then(
        f => cb(f)
      )
    )
  }
}
